import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  PINCODE_MASTER_CACHE_KEY,
  buildUniqueCityOptionsForState,
  buildUniqueStateOptions,
} from '../utils/pincodeMasterUtils';

/**
 * State and city dropdown options derived from the pincode master only.
 */
export function useProposalStateOptions() {
  const pincodeItems = useSelector(
    (state) => state.journey.apiCache?.[PINCODE_MASTER_CACHE_KEY]?.data || [],
  );

  const stateOptions = useMemo(
    () => buildUniqueStateOptions(pincodeItems),
    [pincodeItems],
  );

  const findStateID = (stateName) => {
    const needle = String(stateName ?? '').trim();
    if (!needle) return null;
    const match = stateOptions.find(
      (item) => String(item.value ?? '').trim() === needle,
    );
    return match?.value ?? null;
  };

  return { stateOptions, findStateID, pincodeItems };
}

export function useCityOptionsForState(stateName) {
  const pincodeItems = useSelector(
    (state) => state.journey.apiCache?.[PINCODE_MASTER_CACHE_KEY]?.data || [],
  );

  const cityOptions = useMemo(
    () => buildUniqueCityOptionsForState(pincodeItems, stateName),
    [pincodeItems, stateName],
  );

  return { cityOptions, cities: cityOptions, stateID: null };
}
